// extracted by mini-css-extract-plugin
module.exports = {"passiveFeedbackLink":"passive_feedback_link__passiveFeedbackLink___3QUau"};